export const OWNERSHIP_TYPES = {
  BOARDING: 1,
  RENTING: 5,
};
export const OWNERSHIP_WITH_RENTAL = [
  OWNERSHIP_TYPES.BOARDING,
  OWNERSHIP_TYPES.RENTING,
];
